export default __webpack_public_path__ + "static/media/2044.d58e4d7d.png";